// extracted by mini-css-extract-plugin
export default {"formInput":"UserProfile_formInput__8Ta03"};